export default __webpack_public_path__ + "static/media/setion06_bg_m.fa982868.png";